export const me = /* GraphQL */ `
  query Me {
    me {
      id
      createdAt
      updatedAt
      cognitoUserId
      country
      state
      whatsappNumber
      timeZone
      admin {
        id
        createdAt
        updatedAt
        isActive
        lastSeenOnline
      }
    }
  }
`;

export const messagesByConversationId = /* GraphQL */ `
  query MessagesByConversationId(
    $conversationId: ID!
    $scannedCount: Int
    $nextToken: String
  ) {
    messagesByConversationId(
      conversationId: $conversationId
      scannedCount: $scannedCount
      nextToken: $nextToken
    ) {
      items {
        content
        createdAt
        updatedAt
        id
        isSent
        senderType
        conversationId
        student {
          id
          name
        }
        user {
          id
          admin {
            id
            createdAt
            updatedAt
            firstName
            lastName
            address
            SSN
            gender
            isActive
          }
          instructor {
            id
          }
          preInstructor {
            id
          }
        }
      }
      nextToken
      scannedCount
    }
  }
`;
